<template>
    <base_location_modal :tabs_advanced="tabs_add" :tabs_remove="tabs_remove">
        <template v-slot:location_general_info="{ location, name }">
            <sendpulse_general_tab :location="location"></sendpulse_general_tab>
        </template>

        <template v-slot:location_categories="{ location, name }">
            <sendpulse_fields_tab :location="location" ></sendpulse_fields_tab>
        </template>

        <template v-slot:title_location_categories="{ location, name }">
            <div>Event Fields</div>
        </template>

        <template v-slot:sendpulse_bot_tab="{ location, name }">
            <sendpulse_bot_tab :location="location"></sendpulse_bot_tab>
        </template>


    </base_location_modal>
</template>

<script>

import base_location_modal from "../../base/location_modal/base_location_modal";
import sendpulse_general_tab from "./tabs/sendpulse_general_tab.vue";
import Location_super_categs from "../../base/location_modal/tabs/location_super_categs";
import tilda_fields_tab from "../../tilda/location/tabs/tilda_fields_tab.vue";
import Sendpulse_fields_tab from "./tabs/sendpulse_fields_tab.vue";
import sendpulse_bot_tab from "./tabs/sendpulse_bot_tab.vue";


export default {
    name: "sendpulse_location_modal",
    components : {
        Sendpulse_fields_tab,
        tilda_fields_tab,
        sendpulse_general_tab,
        base_location_modal,
        Location_super_categs,
        sendpulse_bot_tab
    },
    data () {
        return {
            tabs_add: [
                {
                    index : "sendpulse_bot_tab",
                    title : this.__t('SENDPULSE_BOT'),
                },
            ],
            tabs_remove:  [
                'location_logs',
                'location_products',
                'location_source_price'
            ]
        }
    }
}
</script>

<style scoped>

</style>
